import axios from "@/plugins/axios";

let url = "/api/console/statistics/visits";

export const visits = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default visits;
